<div class="login" [ngStyle]="{'background-image': (chosenImage) ? 'url(' + chosenImage + ')' : '' }">
	<div class="login_overlay"></div>

	<main class="login_main">
		<section class="login_card">
			<div class="login_anchor">
				<img src="./../../../../assets/img/anchor.png" alt="Anchor">
			</div>

			<ng-container *ngIf="!showChangePassword; else changePasswordForm">
				<h1>{{'Welcome to PCS Ploče' | translate}}</h1>
				<p>{{'Please sign in to continue' | translate}}</p>

				<form class="login_form">
					<div class="alert alert-danger" role="alert" *ngIf="errorMessage" [textContent]="errorMessage"></div>

					<div class="login_input" [ngClass]="{'is-invalid': !!errorMessage}">
						<i class="fa fa-user-o login_login-icon-big" aria-hidden="true"></i>
						<input type="text" id="username" name="username" [(ngModel)]="username"
							placeholder="{{'Username' | translate}}" required autofocus>
					</div>

					<div class="login_input" [ngClass]="{'is-invalid': !!errorMessage}">
						<i class="fa fa-lock login_login-icon-big" aria-hidden="true"></i>

						<input
							[type]="showPassword ? 'text' : 'password'"
							id="password"
							name="password"
							[(ngModel)]="password"
							placeholder="{{'Password' | translate}}"
							required/>

						<i
							class="fa login_login-icon-big"
							[ngClass]="{
								'fa-eye': !showPassword,
								'fa-eye-slash': showPassword
							}"
							aria-hidden="true"
							(click)="togglePassword()"
							style="cursor: pointer;"></i>
					</div>

					<button type="submit" class="login_button" (click)="signIn()">
						<i class="fa fa-arrow-right login_button-icon"></i>
						<span class="login_button-text">{{'Sign in' |translate}}</span>
					</button>

					<button type="button" class="login_button login_button--secondary" (click)="signUp()">
						<i class="fa fa-user-plus login_button-icon"></i>
						<span class="login_button-text">{{'Sign Up' |translate}}</span>
					</button>
				</form>
			</ng-container>

			<ng-template #changePasswordForm>
				<h1>{{'Change password' | translate}}</h1>
				<p>{{'You need to update/change your password' | translate}}</p>

				<form class="login_form">
					<div class="alert alert-danger" role="alert" *ngIf="errorMessage" [textContent]="errorMessage"></div>

					<div class="login_input" [ngClass]="{'is-invalid': !!errorMessage}">
						<i class="fa fa-lock" aria-hidden="true"></i>

						<input
							[type]="showNewPassword ? 'text' : 'password'"
							name="newPassword"
							[(ngModel)]="newPassword"
							placeholder="{{'New password' | translate}}"
							required
							autofocus/>

						<i
							[ngClass]="showNewPassword ? 'fa-eye-slash' : 'fa-eye'"
							class="fa login_login-icon-big"
							(click)="toggleNewPassword()"
							style="cursor:pointer"></i>
					</div>

					<div class="login_input" [ngClass]="{'is-invalid': !!errorMessage}">
						<i class="fa fa-lock" aria-hidden="true"></i>

						<input
							[type]="showRepeatPassword ? 'text' : 'password'"
							name="repeatNewPassword"
							[(ngModel)]="repeatNewPassword"
							placeholder="{{'Repeat new password' | translate}}"
							required/>

						<i							
							[ngClass]="showRepeatPassword ? 'fa-eye-slash' : 'fa-eye'"
							class="fa login_login-icon-big"
							(click)="toggleRepeatPassword()"
							style="cursor:pointer"></i>
					</div>

					<button type="submit" class="login_button" (click)="changePassword()"
						[disabled]="isBusy || !newPassword || !repeatNewPassword">
						{{'Change password' | translate}}
					</button>
				</form>
			</ng-template>

			<div class="login_divider">
				<span>{{'Co-financed through projects' | translate}}</span>
			</div>

			<div class="login_grid">
				<div class="login_main-project">
					<img src="./../../../../assets/img/DIGITPORTS_LOGO.png" alt="DIGITPORTS"/>
				</div>				
				
				<img src="./../../../../assets/img/INTESA_sm.png" alt="INTESA"/>
				<img src="./../../../../assets/img/PROMARES_sm.jpg" alt="PROMARES"/>
				<img src="./../../../../assets/img/adriaticIpa_sm.jpg" alt="Adriatic IPA"/>
				<img src="./../../../../assets/img/ADRIPASS_sm.png" alt="ADRIPASS"/>

				<!-- bottom row wrapper -->
				<div class="login_bottom">
					<img src="./../../../../assets/img/EU-logo_sm.png" alt="EU"/>
					<img src="./../../../../assets/img/interreg-italy-croatia_sm.jpg" alt="Interreg Italy Croatia"/>
					<img src="./../../../../assets/img/MultiAPPRO_logo_sm.jpg" alt="MultiAPPRO"/>
				</div>

			</div>
		</section>
	</main>
</div>
